<app-header [headerText]="employeeInfo"></app-header>
<div [ngClass]="{'blocked': !currentEmployee}">

    <mat-tab-group class="parent" mat-align-tabs="center" animationDuration="0ms" dynamicHeight=true (selectedTabChange)="tabChanged($event)" [selectedIndex]="contentLocation.tabIndex" *ngIf="currentEmployee">

        <mat-tab [disabled]="false">

            <ng-template mat-tab-label>
                <img class="img-responsive center-block" src="{{general}}" />
            </ng-template>

            <h5 class="mb-4">Información General:</h5>
            <app-employee-general-information [disabled]="true" [employee]="currentEmployee">
            </app-employee-general-information>
            <h5 class="mb-4">Información De Contacto:</h5>
            <app-contact-information [disabled]="true" [contactInformation]="currentEmployee.contactInformation">
            </app-contact-information>

        </mat-tab>

        <mat-tab [disabled]="false">

            <ng-template mat-tab-label>
                <img class="img-responsive center-block" src="{{laboral}}" />
            </ng-template>

            <h5 class="mb-4">Supervisor:</h5>
            <app-employee-ref [disabled]="true" [employeeRef]="logicService.dataManager.principalDataLoader.employee.workInformation.supervisor"></app-employee-ref>
            <h5 class="mb-4">Información Laboral:</h5>
            <app-work-information [disabled]="true" [workInformation]="logicService.dataManager.principalDataLoader.employee.workInformation">
            </app-work-information>

        </mat-tab>

    </mat-tab-group>

</div>